var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('hero'),(_vm.source == 'Search')?_c('div',[_c('search')],1):_vm._e(),(_vm.source == 'Recipes' || _vm.source == 'Category')?_c('div',[_c('recipes')],1):_vm._e(),(_vm.source == 'Recipe')?_c('div',[_c('recipe')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }